import React from 'react';
import { useSelector } from 'react-redux';
import { setBuilderOrderAction } from '../../../../../redux/slices/oldBuilder';
import {
  builderSelectedOptionsSelector,
  funnelOrdersSelector,
} from '../../../../../redux/selectors/builder';
import {
  FunnelOrderKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import { IStyledProps } from '../../../../../styles/types';
import {
  funnelOrderTooltipOption,
  funnelOrderTooltips,
} from '../../../../../components/KubitTooltip/globalTooltips';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { assertCondition } from '../../../../../utils/types';

export default ({ className }: IStyledProps<unknown>) => {
  const dispatch = useAppDispatch();

  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(selectedOptions?.type === QueryType.Funnel);

  const selectedFunnelOrder = selectedOptions.funnelOrder;
  const defaultOrders = useSelector(funnelOrdersSelector);

  const handleFunnelOrderChange = (newOrder: FunnelOrderKey) => {
    dispatch(
      setBuilderOrderAction({
        newOrder,
      }),
    );
  };

  const options = defaultOrders.map((funnelOrder) => ({
    ...funnelOrder,
    tooltip: { content: funnelOrderTooltips[funnelOrder.key].content },
  }));

  return (
    <BuilderEnumSelect
      className={className}
      label="Order"
      enumOptions={options}
      selectedOption={selectedFunnelOrder}
      onChange={handleFunnelOrderChange}
      tooltipOption={funnelOrderTooltipOption}
    />
  );
};
